module.exports = __webpack_public_path__ + "img/envelope-dot.500c84cd.svg";